import { array } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import React from "react";
import { TRoadblockAssignmentForm } from "../../../../../domain/codecs/form/RoadblockAssignmentForm";
import { RoadblockAssigneeRole, RoadblockAssigneeRole_displayString, TRoadblockAssigneeRole } from "../../../../../domain/roadblocks/roadblockAssigneeRoles";
import { FormStatus_highestPriority } from "../../../../../shared/src/codecs/codec";
import { CRMColors } from "../../../models/CRMColors";
import { CRMSpacing } from "../../../models/CRMSpacing";
import { Background } from "../../BuildingBlocks/Background";
import { BackgroundColour } from "../../BuildingBlocks/BackgroundColour";
import { MinHeight } from "../../BuildingBlocks/MinHeight";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { CRMAutosaveIndicatorWrap } from "../../CRM/CRMAutosaveIndicatorWrap/CRMAutosaveIndicatorWrap";
import { CRMDropdownComponent } from "../../CRMDropdownComponent/CRMDropdownComponent";
import CRMInputLabelAndErrorWrapComponent from "../../CRMInputLabelAndErrorWrapComponent/CRMInputLabelAndErrorWrapComponent";
import { CRMParagraph } from "../../Simple/CRMParagraph/CRMParagraph";

const roleOptions = pipe(
    RoadblockAssigneeRole.values,
    array.map((role) => ({
        value: role,
        label: RoadblockAssigneeRole_displayString(role),
    })),
);

export const CRMRoadblockAssignmentBlock = (props: React.PropsWithChildren<{
    assignmentForms: Array<TRoadblockAssignmentForm>,
    onChange: (form: TRoadblockAssignmentForm) => void,
}>): JSX.Element => {
    const formStatus =
        pipe(
            props.assignmentForms,
            array.map(({status}) => status),
            FormStatus_highestPriority,
        );

    const onChangeRole = (form: TRoadblockAssignmentForm) => (assignee_role: TRoadblockAssigneeRole) =>
        props.onChange({
            ...form,
            edited: {
                ...form.edited,
                assignee_role,
            },
        });

    return (
        <BackgroundColour colour={CRMColors.NEUTRAL_PAPER}>
            <MinHeight height={"700px"}>
                <Background padding={CRMSpacing.LARGE}>
                    <CRMAutosaveIndicatorWrap
                        width="100%"
                        status={formStatus}
                    >
                        <SpacingColumn spacing={CRMSpacing.LARGE}>
                            <CRMParagraph>
                                Sets who a roadblock is assigned to when it opens. Roadblocks that are already
                                open keep whoever has them now.
                            </CRMParagraph>

                            <SpacingColumn spacing={CRMSpacing.MEDIUM}>
                                {props.assignmentForms.map((form) =>
                                    <CRMInputLabelAndErrorWrapComponent
                                        key={form.edited.roadblock_type}
                                        label={form.children.display_name}
                                    >
                                        <CRMDropdownComponent
                                            options={roleOptions}
                                            value={form.edited.assignee_role}
                                            onChange={onChangeRole(form)}
                                            displayError={false}
                                        />
                                    </CRMInputLabelAndErrorWrapComponent>
                                )}
                            </SpacingColumn>
                        </SpacingColumn>
                    </CRMAutosaveIndicatorWrap>
                </Background>
            </MinHeight>
        </BackgroundColour>
    );
};
